import { AppPlatform } from './AppPlatform'
import {PosApi} from 'posapi/PosApi'

const routes: IRoute[] = [
	{
		path: '/demo',
		name: 'demo',
        component: AppPlatform,
        layout:'public'
	},
	{
		path: '/posapi',
		name: 'posapi',
        component: PosApi,
        layout:'public'
	},
	
]
export default routes



// WEBPACK FOOTER //
// ./src/demo/index.ts